import actions from './actions';
import mutations from './mutations';
import getters from './getters';

const offlineModule = {
  namespaced: true,
  state() {
    return {
      isOfflineMode: false,
    };
  },
  actions,
  mutations,
  getters,
};

export default offlineModule;
